<template>
<div>
  <div class="extensao_banner">
    <BreadCrumb :breadcrumb="breadcrumb" class="bcp" />
    <h1>SASUMA / {{ $t("UMA_LANG_SASUMA_HOME_FOOTER_DOCUMENTACAO") }}</h1>
  </div>
  <AvisosComunicadosWrapper>
    <SearchRow class="noshowsmall">
      <Searchcombobox
        @selectedOption="filterByTipo"
        :currentOption="selectedTipo"
        :options="tipos" />
      <Searchbox 
        :placeholderText="$t('UMA_LANG_URH_PESQUISADOCUMENTOS')"
        @search-word="searchWord" />
    </SearchRow>
    <div
      class="spinnerholder noshowsmall"
      v-if="isSearching" >
      <SpinText
        :text="$t('apesquisar')"
        class="spinner"/>
    </div>
    <DocumentacaoList
      v-else 
      :listItems="listItems"
      :fetching="fetching">
      <pagination
        @changePage="getPage"
        @loadmore="loadmore"
        :showPagination="listItems.length > 0"
        :pages="pages"
        :currentPage="currentPage" />
    </DocumentacaoList>
  </AvisosComunicadosWrapper>
</div>
</template>

<script>
import axios from "@/axios";
import { ref, onMounted } from 'vue';
import { onBeforeRouteLeave } from 'vue-router';
import { SpinText } from "umaui";
import { i18n } from '@/main.js';
import pagination from '@/components/pagination.vue';
import Searchbox from "@/components/searchbox.vue";
import SearchRow from "@/components/searchRow.vue";
import Searchcombobox from "@/components/searchcombobox.vue";
import DocumentacaoList from "@/components/documentacaolist/documentacaolist.vue";
import BreadCrumb from "@/components/BreadCrumb.vue";
import AvisosComunicadosWrapper from "@/components/AvisosComunicadosWrapper.vue";


export default {
  components:{
    BreadCrumb,
    pagination,
    Searchbox,
    DocumentacaoList,
    SearchRow,
    SpinText,
    AvisosComunicadosWrapper,
    Searchcombobox
  },
  setup() {

    const { t } = i18n.global;
    const lang = i18n.global.locale;
    const lg = lang == "en" ? "/en" : "";

    //#region breadcrumb
    
    const breadcrumb = ref([]);
    onMounted(() => {
      breadcrumb.value = [
        { ID: 1, text: 'Homepage', href: `https://www.uma.pt${lg}` },
        { ID: 2, text: t("breadcrumb.sobre"), href: `https://www.uma.pt${lg}/sobre` },
        { ID: 3, text: t("breadcrumb.apoio"), href: `https://www.uma.pt${lg}/sobre/servico-apoio-estudantes` },
        { ID: 4, text: t("breadcrumb.sas"), route: { to: "/" } },
        { ID: 5, text: t("breadcrumb.documentacao"), href: "#" }
      ]
    })

    var navigationbar = document.getElementsByClassName("title-bar")[0];
    navigationbar.classList.add("black");
    var offcontent = document.getElementsByClassName("off-canvas-content")[0];
    offcontent.classList.add("padding");

    onBeforeRouteLeave(async (to, from) => {
      var navigationbar = document.getElementsByClassName("title-bar")[0];
      navigationbar.classList.remove("black");
      var offcontent = document.getElementsByClassName("off-canvas-content")[0];
      offcontent.classList.remove("padding");
    });

    //#endregion

    const generateYears = () => {
      const currentYear = new Date().getFullYear();
      const startYear = 2022;
      const years = [];
      for (let year = currentYear; year >= startYear; year--) {
        years.push(year);
      }
      years.unshift("Todos os Anos");
      return years;
    };

    const anos = ref(generateYears());
    const selectedAno = ref(new Date().getFullYear());
    const listItems = ref([]);
    const fetching = ref(false);
    const currentPage = ref(1);
    const pages = ref(0);
    const totalElements = ref(0);
    const limit = 10;
    const total = ref(0)
    const filter = ref(null);
    const tipos = ref([
      { label: t("UMA_LANG_SASUMA_DOCUMENTOS_TIPO_TODOS"), value: '' },
      { label: t("UMA_LANG_SASUMA_DOCUMENTOS_TIPO_ALOJAMENTO"), value: 'sasalojamento' },
      { label: t("UMA_LANG_SASUMA_DOCUMENTOS_TIPO_BOLSASESTUDO"), value: 'sasbolsasdeestudo' },
      { label: t("UMA_LANG_SASUMA_DOCUMENTOS_TIPO_ALIMENTACAO"), value: 'sasalimentacao' },
      { label: t("UMA_LANG_SASUMA_DOCUMENTOS_TIPO_PRECARIOS"), value: 'sasprecario' },
      { label: t("UMA_LANG_SASUMA_DOCUMENTOS_TIPO_LEGISLACAO"), value: 'saslegislacao' },
      { label: t("UMA_LANG_SASUMA_DOCUMENTOS_TIPO_INSTRUMENTOS"), value: 'sasiig' },
      { label: t("UMA_LANG_SASUMA_DOCUMENTOS_TIPO_CONTRATACAOPUBLICA"), value: 'sasprocconcursais' }
    ]);
    const selectedTipo = ref("");

    const filterByAno = (selectedOption) => {
      selectedAno.value = selectedOption;
      fetchDocuments();
    };

    const getPage = (page) => {
      window.scrollTo(0,0);
      currentPage.value = page;
      fetchDocuments();
    };

    const loadmore = () => {
      currentPage.value = currentPage.value + 1;
      fetchDocuments(true);
    };

    const pageGenerator = () => {
      const generatePagesArray = (start, end) => Array.from({ length: end - start + 1 }, (_, i) => i + start);

      if (total.value < 8) {
        pages.value = generatePagesArray(1, total.value);
      } else {
        if (currentPage.value < 5) {
          pages.value = [...generatePagesArray(1, 5), '...', total.value];
        } else if (currentPage.value > total.value - 4) {
          pages.value = [1, '...', ...generatePagesArray(total.value - 4, total.value)];
        } else {
          pages.value = [1, '...', currentPage.value - 1, currentPage.value, currentPage.value + 1, '...', total.value];
        }
      }
    };

    let debounceTimer;
    const searchWord = searchfilter => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        currentPage.value = 1;
        filter.value = searchfilter;
        isSearching.value = true;
        fetchDocuments();
      }, 300);
    };

    const filterByTipo = tipo => {
      currentPage.value = 1;
      selectedTipo.value = tipo;
      isSearching.value = true;
      fetchDocuments();
    }

    const calculateSearchParameters = () => {
      var of = (currentPage.value - 1) * limit;
      var url = `?limit=${limit}&offset=${of}&owner=${import.meta.env.VITE_APP_OWNER}&publicado=1&idioma=${lang}&sort=doc_ano&direction=DESC`;
      if(filter.value != null){
        url = `${url}&filter=${filter.value}`;
      }
      if(selectedTipo.value != null){
        url = `${url}&tipo=${selectedTipo.value}`;
      }
      return url;  
    }

    const isSearching = ref(false)

    let controller = new AbortController();

    const fetchDocuments = (shouldAdd = false) => {
      if (controller) {
        controller.abort();
      }
      controller = new AbortController();
      axios.get('/sas/document' + calculateSearchParameters(),{
          signal: controller.signal
        })
        .then(data => {
          listItems.value = !shouldAdd ? data.data.data : 
                        [...listItems.value, ...data.data.data];
          totalElements.value = data.data.total;
          total.value = Math.ceil(data.data.total / limit);
          pageGenerator()
          isSearching.value = false;
        })
        .catch(error => {
          isSearching.value = false;
          console.log(error);
        })
    }

    fetchDocuments()

    return {
      filterByTipo,
      tipos,
      selectedTipo,
      breadcrumb,
      isSearching,
      searchWord,
      selectedAno,
      anos,
      listItems,
      fetching,
      currentPage,
      pages,
      totalElements,
      filterByAno,
      getPage,
      loadmore,
    };
  },
};
</script>

<style scoped>
.spinnerholder{
  position: relative;
  margin-top: 50px;
}

@media screen and (max-width: 767px) {
  .spinnerholder{
    display: none;
  }
}

.extensao_banner h1 {
  text-align: center;
  font-family: "Montserrat Bold";
  font-size: 60px;
  color: #3f4244;
  padding-top: 105px;
  padding-bottom: 30px;
  transform: translate3D(0, -10px, 0);
}

.extensao_banner h1 {
  font-size: 55px;
  color: #4d5354;
}

.bcp {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 90;
  padding-top: 15px;
  top: 110px;
}

@media (max-width: 1400px) {
  .extensao_banner h1 {
    font-size: 48px;
  }
}

@media (max-width: 1024px) {
  .extensao_banner h1 {
      font-size: 40px;
  }
}

@media (max-width: 767px) {
  .noshowsmall{
    display: none;
  }

  .extensao_banner h1 {
    font-size: 25px !important;
    padding-top: 35px;
    padding-bottom: 0px;
  }
}

.wrcl{
  padding-left: 0;
  padding-right: 0;
}
</style>
  